import { animate, AUTO_STYLE, state, style, transition, trigger } from "@angular/animations";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { Component, ViewChild } from '@angular/core';
import { Title } from "@angular/platform-browser";
import {
    ActivatedRoute, Data,
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterLink, RouterLinkActive,
    RouterOutlet,
} from '@angular/router';
import { FooterComponent } from "@core/components/footer/footer.component";
import { HeaderComponent } from "@core/components/header/header.component";
import { LoginComponent } from "@core/components/login/login.component";
import { NotificationsOutletComponent } from '@core/components/notifications-outlet/notifications-outlet.component';
import { PortalMenueComponent } from '@core/components/portal-menue/portal-menue.component';
import { UserNavigationComponent } from "@core/components/user-navigation/user-navigation.component";
import { WichtigeInformationenComponent } from "@core/overlays/wichtige-informationen/wichtige-informationen.component";
import { SeiteComponent } from "@core/views/seite/seite.component";
import { LoginService } from "@core/services/login/login.service";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { MenubarModule } from "primeng/menubar";
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { filter } from 'rxjs';
import { IsLoadingServiceService } from 'src/app/core/services/is-loading/is-loading-service.service';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FaIconLibrary} from "@fortawesome/angular-fontawesome";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";
import {faBars} from "@fortawesome/free-solid-svg-icons";
import {faPrint} from "@fortawesome/free-solid-svg-icons";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {faAngleDoubleRight} from "@fortawesome/free-solid-svg-icons";
import {faGlobeAmericas} from "@fortawesome/free-solid-svg-icons";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import {faAngleDown} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        NotificationsOutletComponent,
        PortalMenueComponent,
        ProgressBarModule,
        RouterOutlet,
        TableModule,
        RouterLink,
        RouterLinkActive,
        SeiteComponent,
        NgOptimizedImage,
        LoginComponent,
        NgIf,
        HeaderComponent,
        FooterComponent,
        UserNavigationComponent,
        MenubarModule,
        FaIconComponent,
        FontAwesomeModule,
        DialogModule,
        ConfirmDialogModule,
        WichtigeInformationenComponent,
    ],
    animations: [
        trigger('collapse', [
            state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
            state('true', style({ height: '0', visibility: 'hidden' })),
            transition('false => true', animate(400 + 'ms ease-in')),
            transition('true => false', animate(400 + 'ms ease-out'))
        ])
    ]
})
export class AppComponent {
    currentRoute: ActivatedRoute;
    currentData: Data;
    isHome: boolean = false;
    isLoggedIn: boolean;
    isCollapsed: boolean;

    @ViewChild(WichtigeInformationenComponent) wichtigeInformationen: WichtigeInformationenComponent;

    constructor(
        protected isLoadingService: IsLoadingServiceService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private loginService: LoginService,
        library: FaIconLibrary,
        private confirmationService: ConfirmationService
    ) {
        library.addIcons(faEnvelope, faBars, faPhone, faPrint, faInfoCircle, faAngleDoubleRight, faGlobeAmericas, faCalendar, faAngleDown);

        this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
            this.isLoadingService.add('Routing');
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel)).subscribe(() => {
            this.isLoadingService.remove('Routing');
        });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
        ).subscribe(() => {

            this.currentRoute = this.holeChild(this.activatedRoute);

            this.currentRoute.data.subscribe((data) => {
                console.log(data);
                this.titleService.setTitle(data["title"]);
                this.currentData = data["title"];

                this.isHome = data["title"];
            });

            if (!document.cookie.includes("information=gelesen")) {
                this.wichtigeInformationen.openOverlay();
            }
        });

        this.loginUeberpruefen();
    }

    loginUeberpruefen() {
        this.loginService.isLoggedIn.subscribe((data) => {
            this.isLoggedIn = data;
        });
    }

    toggleMenu() {
        this.isCollapsed = !this.isCollapsed;
    }

    angularRequirements = [
        { name: 'Angular', version: '18.1.x || 18.2.x' },
        { name: 'Node.js', version: '^18.19.1 || ^20.11.1 || ^22.0.0' },
        { name: 'TypeScript', version: ' >=5.4.0 <5.6.0' },
        { name: 'RxJS', version: '^6.5.3 || ^7.4.0' },
    ];

    holeChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild) {
            return this.holeChild(activatedRoute.firstChild);
        } else {

            return activatedRoute;
        }

    }
}
